import useApiErrorHandling from '../../useApiErrorHandling';

// Terminal handler for a control action: onClick discards the returned promise and
// the app has no ErrorBoundary or unhandledrejection listener, so nothing past this
// point can report or contain a failure.
export const guardControlAction =
  (
    action: () => unknown,
    handleApiError: ReturnType<typeof useApiErrorHandling>
  ) =>
  async (): Promise<unknown> => {
    try {
      return await action();
    } catch (error) {
      await handleApiError(
        error instanceof Error ? error : new Error(String(error))
      );
      return undefined;
    }
  };
